import type { ReactNode } from 'react'

import logo from '@fv/client-assets/freightview.svg'

type SharedShipmentHeaderProps = {
  children: ReactNode
}

const SharedShipmentHeader = ({ children }: SharedShipmentHeaderProps) => {
  return (
    <div className="px-6 py-4 border-fv-gray border-b justify-center bg-fv-blue-50 col-span-full flex items-center b600:flex-col b600:gap-y-2 b600:px-4 b600:py-3 b600:text-center">
      <img src={logo} alt="Freightview" className="b600:h-8 b600:w-auto" />
      <span className="mb-0">
        <p className="mb-0 ml-2 b600:ml-0">{children}</p>
      </span>
    </div>
  )
}

export default SharedShipmentHeader
